import NextImageWithShimmer from 'components/image/NextImageWithShimmer';
import { mediaMSmMax } from 'helpers/breakpoints';
import styled from 'styled-components';

interface HeroProps {
  images: {
    desktop: string;
    mobile: string;
  };
}
const Hero = ({ images }: HeroProps) => {
  // CloudFront/S3 requires that no leading slash is used in the path
  const heroPath = 'spa/homepage/hero/';

  return (
    <HeroWrapper data-testid="homepage-hero-wrapper">
      <BgImageWrapper className="hero-desktop">
        <NextImageWithShimmer
          fetchPriority="high"
          priority
          src={`${heroPath}${images.desktop}`}
          alt=""
          data-testid="homepage-hero-image"
          fill
          sizes="100vw"
        />
      </BgImageWrapper>
      <BgImageWrapper className="hero-mobile">
        <NextImageWithShimmer
          fetchPriority="high"
          priority
          src={`${heroPath}${images.mobile}`}
          alt=""
          fill
          sizes="100vw"
        />
      </BgImageWrapper>
      <div className="text" data-testid="homepage-hero-text">
        <h1>Browse, book, boat</h1>
        <h2>
          Boat rentals, Captain-led trips, <SmallBreak />& on-the-water experiences.
        </h2>
      </div>
    </HeroWrapper>
  );
};

export default Hero;

const HeroWrapper = styled.div`
  display: flex;
  min-height: 575px;
  position: relative;
  margin-bottom: -160px;
  justify-content: center;

  ${mediaMSmMax} {
    min-height: 428px;
    margin-bottom: -80px;
  }

  h2 {
    padding-bottom: 0px;
    margin-bottom: 0px;
    font-size: 24px;
    line-height: 34px;
    font-weight: 500;
    text-align: center;

    ${mediaMSmMax} {
      line-height: 130%;
      font-size: 18px;
    }
  }

  h1 {
    font-weight: bold;
    font-size: 56px;
    z-index: 1;
    text-align: center;

    ${mediaMSmMax} {
      font-size: 32px;
    }
  }

  .text {
    color: #ffffff;
    z-index: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 70px;
    padding: 0 16px;

    ${mediaMSmMax} {
      margin-top: 35px;
    }
  }

  img {
    object-fit: cover;
    object-position: 50% 40%;
  }
`;

const SmallBreak = styled.br`
  display: none;

  @media (max-width: 600px) {
    display: block;
  }
`;

const BgImageWrapper = styled.div`
  width: 100%;
  margin-top: auto;
  position: absolute;
  height: 595px;

  ${mediaMSmMax} {
    height: 428px;
  }

  &.hero-mobile {
    display: none;
  }

  @media (max-width: 640px) {
    &.hero-desktop {
      display: none;
    }
    &.hero-mobile {
      display: block;
    }
  }
`;
